module.exports = __webpack_public_path__ + "static/flags/BH-7152b20800f95ffa5a55663d803153ec.gif";